import type { BrandConfig } from './types';
import { BRAND_HTML_META } from './htmlMeta';
import logoWhite from '../../assets/show-hin-jo-hin_white.png';
import logoDark from '../../assets/show-hin-jo-hin_black.png';

/**
 * 商品上品（デフォルト）ブランド設定
 */
export const shohinJohinBrand: BrandConfig = {
  id: 'default',
  serviceName: BRAND_HTML_META.default.serviceName,
  companyName: 'Light Media, Inc.',
  favicon: BRAND_HTML_META.default.favicon,
  logoWhite,
  logoDark, // 明色ログイン画面など明色背景向け（黒ロゴ）
  colorScheme: 'light',
  colors: {
    // 3 色構成:
    //   primary  = サンドベージュ (共有フォルダタブ active 等の大きい主要面)
    //   sub      = セージミント (個人フォルダタブ active や生成ステータスバー等の補助面)
    //   accent   = サンドベージュ (主要 CTA ボタン / フォーカス / 選択リング, 暫定で primary と同色)
    primary: '#CBC19F',
    primaryHover: '#B7AE8F',
    primaryRgb: '203 193 159',
    subSolid: '#9ED1C2',
    subSolidHover: '#8EBCAF',
    subRgb: '158 209 194',
    accentSolid: '#CBC19F',
    accentSolidHover: '#B7AE8F',
    accentRgb: '203 193 159',
    bgGradientStart: '#4a4a4a',
    bgGradientEnd: '#3d3d3d',
  },
  urls: {
    website: 'https://show.lightmedia.jp',
    contact: 'https://show.lightmedia.jp/contact',
    privacy: 'https://www.lightmedia.jp/privacy',
  },
  features: {
    promptVisibility: false,
    helpCenter: true,
    navigationGuide: false,
    omakasePlan: false,
    amazonIntegration: true,
    googleIntegration: true,
    canvaIntegration: true,
    skuFields: true,
    salesEmail: true,
    gtm: BRAND_HTML_META.default.gtm,
    oemAttributeManagement: true,
    platformAdmin: true,
    signupEnabled: true,
    mainNavTabs: true,
    appChrome: true,
    publicHome: false,
    // 動画のプロンプト入力モードの 3 タブ目「モーショングラフィックス」(段階 3 の完了 = 一般公開)。
    // true でも backend の暫定ゲート (GET /api/motion-layered/availability の reason='restricted') の間は出ない。
    // レンダラーの状態では消さない (生成の受付で確かめる)。料金行未適用はタブを出したまま生成ボタンを無効にする
    motionGraphicsPromptMode: true,
  },
  labels: {
    tag: 'タグ',
    tags: 'タグ',
    tagManagement: 'タグ管理',
    brand: 'ブランド',
    brands: 'ブランド',
    brandManagement: 'ブランド管理',
    aiActor: 'AI俳優',
    aiActors: 'AI俳優',
    product: '商品データ',
    products: '商品データ',
    material: '素材',
    materials: '素材',
    studio: '生成',
    studioShort: '生成',
    organization: '組織',
    organizations: '組織',
    member: 'メンバー',
    members: 'メンバー',
    invitation: '招待',
    attributeMode: '属性選択モード',
    scenarioMode: 'シナリオモード',
    scenarioModeBase: 'シナリオ',
    scenarioNoun: 'シナリオ',
    scenarioSettings: 'シナリオ生成設定',
    scenarioGenerate: 'シナリオを生成',
    scenarioRegenerate: 'シナリオを再生成',
    scenarioEdit: 'シナリオ編集',
    productName: '商品名',
    productDescription: '商品の説明',
    productNewDefault: '商品情報を入力してください',
    productShort: '商品',
  },
  exportSettings: {
    resolutions: ['720p', '1080p', '2K', '4K'],
    formats: {
      video: ['mp4'],
      image: ['jpg', 'png'],
    },
  },
  platforms: [],
  auth: {
    notFoundGuidance: {
      type: 'internal',
      path: '/auth/signup',
      messagePrefix: 'アカウントが見つかりませんでした。',
      linkLabel: '新規登録',
      messageSuffix: 'からアカウントを作成してください。',
    },
  },
  homePageVariant: 'default',
  homePage: {
    promptPlaceholder: '例：透明感を持った20代女性 / ナチュラル雰囲気 / SNS広告用 / 春のイメージで明るく',
  },
};
